// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as LinkComponent} from './Link.svg';

import Icon, { TIconProps } from '../Icon';

export const IconLink = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <LinkComponent/>
  </Icon>
));
